import React from "react";

import { CheckboxInput } from "../../../../forms/components";

class CreateMerchantGateway extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		const { gateway, MDRTypes, acceptType } = this.props;
		return (
			<div className="uk-margin-bottom">
				<h4 className="uk-margin-remove">
					<span className="uk-flex uk-flex-middle">
						<i
							className="uk-margin-small-right form-header-icon"
							uk-icon="icon: fa-solid-door-open; ratio: 0.9"
						/>
						Payment Gateway
					</span>
					<hr className="uk-margin-small-top uk-margin-small-bottom" />
				</h4>
				<div className="new-gateway-table uk-padding-small uk-padding-remove-vertical">
					<table className="uk-table uk-table-striped uk-table-middle">
						<thead>
							<tr>
								<th className="uk-text-center">Gateway</th>
								<th>Accepted Payment Type</th>
							</tr>
						</thead>
						<tbody>
							{Object.keys(gateway).map((key) => (
								<tr key={key}>
									<td className="uk-text-center">
										<img
											className="uk-img"
											src={`data:image/*;base64,${gateway[key].image}`}
											width="50"
											height="auto"
										/>
										{/* <span className="uk-margin-left">{gateway[key].name}</span> */}
									</td>
									<td>
										<div className="uk-flex uk-flex-between uk-flex-left@s uk-flex-wrap">
											{Object.keys(MDRTypes).map((type) => {
												if (MDRTypes[type]?.isAdhoc !== true)
													return (
														<CheckboxInput
															key={type}
															noMargin={true}
															label={MDRTypes[type].label}
															name={`accepted.${key}.${type}`}
															handleChange={(value) =>
																acceptType(key, type, value)
															}
														/>
													);
											})}
										</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		);
	}
}

export default CreateMerchantGateway;
